<template>
  <div
    :id="data.id"
    v-lazy-background="backgroundImage"
    class="h-[512px] bg-[length:auto_100%] bg-bottom bg-no-repeat pt-14 text-slate sm:h-[620px] md:h-[54.75rem] md:h-[800px] md:pt-[4.5rem] lg:h-[876px] 3xl:bg-[length:100%_auto]"
  >
    <div
      class="container relative flex h-full flex-col justify-between overflow-hidden"
    >
      <div class="text-center">
        <UiSectionTitle
          v-if="data.title"
          :title="data.title"
          tag="h1"
          class="title mb-2 text-3xl uppercase leading-none md:text-[3.5rem]"
        />

        <div
          v-if="data.text"
          class="mb-6 font-segoe text-md leading-[1.813rem] md:whitespace-pre-line"
          v-html="data.text"
        />

        <div v-if="data.button && data.button.isVisible" class="mb-6">
          <UiButton
            size="md"
            :to="data.button.link"
            :target="data.button.target"
          >
            <span v-html="data.button.text" />
          </UiButton>
        </div>
      </div>

      <div v-if="data.markers && data.markers.length">
        <UiMarkerPoint
          v-for="(marker, mi) in data.markers"
          :key="mi"
          :marker="marker"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useBreakpoint, useMediaAsset } from '~/composables';

interface Props {
  data?: any;
}

const props = withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { getAssetUrl } = useMediaAsset();
const { isBiggerThanBreakpoint: isMobile } = useBreakpoint('md');

const backgroundImage = computed(() =>
  getAssetUrl(isMobile.value ? props.data.image : props.data.imageMobile),
);
</script>
